<i18n src="@/locales/modules/TitleTranslate.json"></i18n>

<template>
	<div class="cbs-watcher">
		<TitleConfig
			class="my-4"
			v-for="(title, index) in localTitles"
			v-model="localTitles[index]"
			:key="`title-${index}`"
			:formName="`title-${index}`"
			@onClickDelete="() => deleteItem(title, index)"
		/>

		<div class="border-dashed my-4 border rounded">
			<vs-button color="#fff" type="filled" class="w-full" text-color="rgb(30,30,30)" @click="addMoreTitles">{{ $t("Addmore") }}</vs-button>
		</div>
	</div>
</template>

<script>
import * as _ from "lodash";

import TitleConfig from "./TitleConfig";

const initTitle = {
	id: null,
	name: null
};

export default {
	name: "AddTitle",

	props: {
		value: {
			type: Array,
			default: () => []
		}
	},
	components: {
		TitleConfig
	},
	data() {
		return {};
	},
	computed: {
		localTitles: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	methods: {
		addMoreTitles() {
			this.localTitles = [...this.localTitles, _.cloneDeep(initTitle)];
		},
		deleteItem(title, index) {
			this.$emit("onDelete", title, index);
		}
	}
};
</script>
